import React from 'react'
import { Dialog } from 'primereact/dialog'
import DialogFooter from '../dialogFooter'
import ConstantsUtil from '../../context/constantsUtil'
import * as popUp from '../toastr'
import GeneralServices from '../../app/service/generalServices'
import NfseService from '../../app/service/nfse/NfseService'
import HandleErrorService from '../../app/service/handleErrorService'
import AuthService from '../../app/service/authService'

import FileUploadCard from '../fileUploadCard'
import Card from '../card'

class ImportacaoNfsePDFDialog extends React.Component {

    constructor(){
        super()
        this.nfseService = new NfseService()
    }

    state = {
        completedUpload: false,
    }

    hideDialog = () => {
        this.setState({completedUpload: false})
        this.setState({inProgressToSave: false})
        // this.setState({fichaBancaria: {}})
        this.props.hideDialog()
    }

    onFinishUpload = (progressKey) => {
        // console.log("onFinishUpload: ", progressKey)
        this.nfseService.getUploadNfseResult(progressKey)
        .then(response => {
            // console.log("onFinishUpload: ", response.data)
            this.setState({fichaBancaria: response.data})
            this.setState({completedUpload: true})
            if(this.props.onFinishUpload){
                this.props.onFinishUpload(response.data)
            }
            // console.log("nfse result: ", response.data)
        })
        .catch(error => {
            // console.log("error: ", error)
            HandleErrorService.handleError(error)
        })
    }


    render() {

        const uploadDialogFooter = (
            <DialogFooter save={this.callSave} hideDialog={this.hideDialog} disabled={!this.state.completedUpload || this.state.inProgressToSave} />
        )        

        const renderUpload = () => {
            if(!this.state.completedUpload){
                return (
                    <>
                        <FileUploadCard
                            uploadInProgress = {this.setIfIsInProgress}
                            accept=".pdf"
                            uploadDescription={ConstantsUtil.importacaoPDFNfse}
                            onFinish={this.onFinishUpload}
                            sendFiles={this.props.getUploadFiles}
                        />
                    </>
                )            
            }
        }

        return(

                <Dialog
                    visible={this.props.visible}
                    style={{ maxHeight: '95vh', width: '85vw'}}
                    modal
                    className="p-fluid"
                    baseZIndex={-1}
                    footer={uploadDialogFooter}
                    onHide={this.hideDialog}>
                    <div className="p-field">
                    <Card
                        title = {"Importação de NFSe em PDF"}
                        // rightComponent={renderRightTooltipButton()}
                    >
                        {renderUpload()}
                        {/* {renderFichaBancaria()}
                        {renderProgressBar()} */}
                    </Card>
                    </div>
    
                </Dialog>             

        )
    }


}


export default ImportacaoNfsePDFDialog